export default __webpack_public_path__ + "static/media/Hashtag Hijacking Insights - 01 - Efficient hashtag.3c479c1c.pdf";